import { Typography } from "@mui/material";

export default function TooltipText({ text = "" }: Readonly<{ text: string }>) {
	if (!text) {
		return null;
	}
	return <Typography className="!font-['PTSansPro'] !text-[12px]">{text}</Typography>;
}
